import { blockedPagesByCountryCode } from './consts'
import { useVpnCheck } from './useVpnCheck'
import { Route } from '@/routing/router'

export function useBlockedPages(): Route[] {
  if (import.meta.env.VITE_FEATURE_BLOCK_REGIONS !== '1') {
    return []
  }
  // biome-ignore lint/correctness/useHookAtTopLevel: <missing explanation>
  const vpnCheck = useVpnCheck()

  if (vpnCheck.data?.countryCode && blockedPagesByCountryCode[vpnCheck.data.countryCode] !== undefined) {
    return blockedPagesByCountryCode[vpnCheck.data.countryCode]!
  }

  return []
}
